<template>
    <b-overlay :show="busy" rounded="sm">

        <b-card class="standardpage reports invoices border-none">
            <div class="availtable datatable">
                <b-card class="w-100pct">

                    <b-card-body class="py-0 px-0">
                        <b-tabs class="gridtabs">
                            <b-tab>
                                <template #title>
                                    <i class="fa fa-university mr-1"></i>
                                    {{ item.invoiceno ? item.invoiceno : 'new' }} Remittance
                                </template>

                                <p class="mt-2">

                                    <b-row class="my-2">

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Transaction Ref" label-for="tranref" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.invoiceno"
                                                        placeholder="Transaction Ref" size="sm" trim
                                                        :disabled="false"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.invoiceno = ''" :disabled="false">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Transaction Date" label-size="sm">
                                                <b-input-group>
                                                    <v-date-picker v-model="item.date" mode="date" is24hr color="green"
                                                        :locale="'en-gb'" class="form-control form-control-sm">
                                                        <template v-slot="{ inputValue, inputEvents }">
                                                            <input
                                                                class="
                                                                                                                                                                            h-19px
                                                                                                                                                                            border-none
                                                                                                                                                                            focus:outline-none focus:border-primary
                                                                                                                                                                            text-primary
                                                                                                                                                                            "
                                                                :value="inputValue" v-on="inputEvents" />
                                                        </template>
                                                    </v-date-picker>
                                                    <b-input-group-append>
                                                        <b-button size="sm" squared variant="outline-secondary"
                                                            :disabled="!item.date" @click="item.date = null">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>



                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Transaction Value" label-for="valuecleared"
                                                label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.valuecleared"
                                                        placeholder="Value" size="sm" trim :disabled="false"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.valuecleared = ''" :disabled="false">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Cash Type" label-for="cashtype" label-cols="12">

                                                <treeselect v-model="item.cashtype" :clearable="true"
                                                    :options="options_cashtype" placeholder="Show all..."></treeselect>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Your Ref" label-for="yourref" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.yourref" placeholder="Your Ref"
                                                        size="sm" trim :disabled="false"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.yourref = ''" :disabled="false">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                                                <treeselect placeholder="Select slac..."
                                                    searchPromptText="Type at least 3 chars..." v-model="item.slac"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                                                    :show-count="true" :flatten-search-results="true"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                    :disabled="readonly_age">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mt-3 mb-3 mx-n3">
                                        <b-col cols="auto" class="mr-auto"> <b-list-group horizontal="md" size="sm">
                                                <b-list-group-item variant="dark"><span class="list-label">To:
                                                        {{ item.slac }}</span> {{ item.to }}</b-list-group-item>
                                                <b-list-group-item variant="dark"><span class="list-label">Your
                                                        Ref/PO:</span>{{ item.yourref }}</b-list-group-item>
                                                <b-list-group-item variant="dark"><span class="list-label">Ref:
                                                    </span>{{ item.invoiceno }}</b-list-group-item>
                                                <b-list-group-item variant="dark"><span class="list-label">Date:</span>{{
                                                    $moment(date).format("DD/MM/YYYY")
                                                }}</b-list-group-item>
                                                <!-- <b-list-group-item variant="dark"><span class="list-label">Due
                                                        on:</span>{{ item.datedue }}</b-list-group-item> -->

                                            </b-list-group></b-col>
                                        <b-col cols="auto"> <b-list-group horizontal="md" size="sm">

                                                <!-- <b-list-group-item variant="dark-primary"><span class="list-label">Paid:</span>{{item.saletotal | currency("") }}</b-list-group-item>
                                            <b-list-group-item variant="dark-primary"><span class="list-label">Due:</span>{{item.outstanding | currency("") }}</b-list-group-item> -->
                                                <b-list-group-item variant="dark-primary"><span
                                                        class="list-label">Payment:</span>{{ credited.toFixed(2) |
                                                            currency("")
                                                        }}</b-list-group-item>

                                            </b-list-group></b-col>
                                        <div>

                                        </div>
                                    </b-row>
                                    <b-tabs>
                                        <b-tab>
                                            <template #title>
                                                <div class="badgecontainer pr-1 mr-1 w-80px">
                                                    <i :class="lines.icon" class="mr-1"></i> Items
                                                    <b-badge variant="white" class="edit_tab">
                                                    </b-badge>

                                                </div>
                                            </template>
                                            <b-row>
                                                <b-col>
                                                    <d-table classdivtable="availtable datatable nested " refid="segments"
                                                        :icon="lines.icon" :selectmode="'multi'" :busy="lines.busy"
                                                        :tools="lines.tools" :badges="lines.badges" :fields="lines.fields"
                                                        :selectall="lines.selectall" :items="lines.items" :page="lines.page"
                                                        :showpages="false" @load="lines_load" @click="lines_click"
                                                        @select="lines_select">
                                                    </d-table>
                                                    <div v-if="component">
                                                        <component :is="component" :selection="lines.selected"
                                                            :config="cconfig" @discard="lines_click('discard')"
                                                            @refresh="lines_click('refresh')"></component>
                                                    </div>
                                                </b-col>
                                            </b-row>

                                        </b-tab>

                                    </b-tabs>
                                </p>

                            </b-tab>
                            <b-tab>
                                <template #title>
                                    <i class="fa fa-comments-o text-primary mr-1"></i>
                                    Notes</template>
                                <p class="py-3 px-0">
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group label="Comments" label-for="comments" label-cols="12">
                                                <b-form-textarea id="data" v-model="item.moreinfo" placeholder="Comments"
                                                    rows="6" class="smalltextarea" :disabled="
                                                        user.permissions.includes('salesledger.admin')
                                                            ? false
                                                            : true
                                                    "></b-form-textarea>
                                            </b-form-group> </b-col></b-row>

                                </p>
                            </b-tab>

                        </b-tabs>

                    </b-card-body>
                    <!-- <b-card-footer class="border-none mt-n4 pt-0 px-0">
                        <b-row no-gutters> <b-col class="text-right pt-1 font-14px">
                                <div>
                                    <span class="ml-1">Credit: GBP <span class="text-danger">{{ credited.toFixed(2) |
                                        currency("") }}</span></span>

                                </div>
                            </b-col>
                        </b-row>
                    </b-card-footer> -->
                    <b-card-footer class="nopadding mt-2">
                        <b-row  class="mb-4">
                            <b-col cols="12" sm="6" md="4" >
                                <b-form-group label-cols="12" label="Invoice No" label-size="sm">
                                    <b-input-group>
                                        <treeselect placeholder="Select invoice no..."
                                            searchPromptText="Type at least 3 chars..." v-model="invoicenoadd" :async="true"
                                            :load-options="treeselect_loadSLInvoiceno" :show-count="true" :multiple="true"
                                            :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                                            search-nested>
                                            <div slot="value-label" slot-scope="{ node }">
                                                {{ node.raw.id }}
                                            </div>
                                        </treeselect>
                                      
                                    </b-input-group>

                                </b-form-group>
                            </b-col>
                            <b-col cols="auto" style="margin-top:17px; ">
                                <b-button size="sm" variant="primary" 
                                                @click="lines.item.invoiceno = ''" :disabled="false">
                                                <i class="fa fa-plus"></i>Add
                                            </b-button>
                            </b-col>
                        </b-row>
                        <b-row no-gutters>
                            <b-col cols="auto" class="text-left mr-4">
                                <b-button squared size="sm" variant="primary" @click="saveit()"
                                    v-if="user.permissions.includes('salesledger.save')">
                                    <i class="fa fa-check"></i>
                                    Post It
                                </b-button>
                            </b-col>
                            <b-col class="text-left">
                                <div v-if="busy">
                                    <i class="fa fa-spinner fa-spin text-primary"></i>
                                </div>
                                <div v-else>
                                    <span v-html="message"></span>
                                </div>
                            </b-col>
                            <b-col class="text-right" cols="8">
                                <b-button squared size="sm" variant="secondary" @click="discard">
                                    <i class="fa fa-chevron-left pr-1"></i>
                                    Back
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-card-footer>
                </b-card>
            </div>
        </b-card>
    </b-overlay>
</template>
  
<script>
import gql from "graphql-tag";

export default {
    name: "SLItemEdit",
    async mounted() {
        this.item.agent = this.user.initials;
    },
    data() {
        return {
            busy: false,
            message: "",
            invoiceno: null,
            invoicenoadd: [],
            date: this.$moment().format("YYYYY/MM/DD"),
            valuecleared: "0.00",
            credit: false,
            credited: 0,
            subtotal: 0,
            totalvat: 0,
            total: 0,
            selected_option: [],
            cashtype: "AL",
            options_cashtype: [
                { label: 'AX | Amex', id: 'AX' },
                { label: 'BT | Bank Transfer', id: 'BT' },
                { label: 'CH | Cash', id: 'CH' },
                { label: 'CQ | Cheques', id: 'CQ' },
                { label: 'DA | Delta Card', id: 'DA' },
                { label: 'MC | Mastercard', id: 'MC' },
                { label: 'MO | Maestro Card', id: 'MO' },
                { label: 'SP | Sage Pay London', id: 'SP' },
                { label: 'SW | Switch', id: 'SW' },
                { label: 'VI | VISA', id: 'VI' },
                { label: 'ZM | Zero Checque Cash Match', id: 'ZM' },
                { label: 'VM | Void Ticket Matching', id: 'VM' },
                { label: 'AM | Adjustment Matching', id: 'AM' },
                { label: 'AL | Allocation of unallocated payment', id: 'AL' },
                { label: 'CM | Credit Note Matching', id: 'CM' },
                { label: 'WO | Write off Bad Debt - Non Chase', id: 'WO' },
                { label: 'WOC | Write off Bad Debt', id: 'WOC' },
            ],
            options_credit: [
                { text: 'Credit S/L', value: 'creditsl' },
                { text: 'Credit ZHOLD', value: 'creditzhold' },
                { text: 'Credit B/L', value: 'creditbl' },
                { text: 'Credit Fees', value: 'creditfees' },

            ],
            reasontype: [],
            options_reasontype: [
                { id: "BT", label: "BTA Card Error" },
                { id: "OE", label: "Operator Error" },
                { id: "RF", label: "Refund" },
                { id: "RI", label: "Reinvoice" },
                { id: "ST", label: "Staff Travel" },
                { id: "VD", label: "Void" },
            ],
            suppliertype_options: [],
            invoicetype_options: [
                { id: "A", label: "A ( air )" },
                { id: "X", label: "X ( air )" },
                { id: "C", label: "C ( car )" },
                { id: "H", label: "H ( hotel )" },
            ],
            vatcode_options: [
                { id: "0", label: "0" },
                { id: "1", label: "1" },
            ],
            multiple: true,
            item: {
                type: "A",
                datetax: this.$moment().format("YYYY-MM-DD"),
                datedepart: this.$moment().format("YYYY-MM-DD"),
                slac: null,
                agent: null,
                ticketno: null,
                items: [{ name: "Passenger 1", ticketno: "abc", id: 0 }],
            },
            items: [],
            salecode_options: [
                {
                    id: "CI",
                    label: "CI | Commissionable Item",
                },
                {
                    id: "DT",
                    label: "DT | Domestic Ticket",
                },
                {
                    id: "IT",
                    label: "IT | International Ticket",
                },
                {
                    id: "MT",
                    label: "MT | Miscellaneous Item",
                },
                {
                    id: "MU",
                    label: "MU | Marked Up Item",
                },
                {
                    id: "NF",
                    label: "NF | Net Fare",
                },
                {
                    id: "NN",
                    label: "NN | Net Net Remit",
                },
                {
                    id: "TF",
                    label: "TF | Transaction Fee Item",
                },
                {
                    id: "UK",
                    label: "UK | Marked Up Item (UK With VAT)",
                },
                {
                    id: "VI",
                    label: "VI | Commissionable Item (UK With VAT)",
                },
            ],

            lines: {
                title: "Invoices",
                icon: "fa fa-wpforms text-info",
                debounce: 500,
                busy: false,
                selectall: false,
                tools: "go,export,deleteconfirm",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px text-primary",
                    },
                    {
                        key: "invoiceno",
                        label: "InvoiceNo",
                        sortable: true,
                        class: "text-right w-80px",
                    },
                    {
                        key: "date",
                        label: "Date",
                        sortable: true,
                        class: "text-center",
                        formatter: (value, key, item) => {
                          let result = "";
                          if (value) {
                            result = this.$moment
                              .unix(value / 1000)
                              .format("DD/MM/YYYY HH:mm" );
                          } 
                          return result;
                        },
                    },
                    {
                        key: "yourref",
                        label: "Your Ref/PO",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 20) {
                                    result = result.slice(0, 17) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "slac",
                        label: "SL A/C",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "eventcode",
                        label: "Event",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "datetravel",
                        label: "DateTravel",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = value.split(" ")[0];
                            }
                            return result;
                        },
                        formatter: (value, key, item) => {
                          let result = "";
                          if (value) {
                            result = this.$moment.unix(value / 1000).format("DD/MM/YYYY");
                          }
                          return result;
                        },
                    },
                    {
                        key: "saletotal",
                        label: "Paid",
                        sortable: true,
                        class: "text-right",
                        formatter: (value, key, item) => {
                            if (value) {
                                return parseFloat(value).toFixed(2);
                            } else {
                                return value;
                            }
                        },
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "outstanding",
                        label: "Due",
                        sortable: true,
                        class: "text-right",
                        formatter: (value, key, item) => {
                            if (value) {
                                return parseFloat(value).toFixed(2);
                            } else {
                                return value;
                            }
                        },
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "refcredit",
                        label: "Cr Ref",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "lines",
                        label: "Lines",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "credit",
                        label: "Type",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "agent",
                        label: "Agent",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-100px w-sm-100pct",
                    },
                ],
                badges: [
                    {
                        key: "credit",
                        type: "badge",
                        Credit: "danger",
                        Invoice: "primary",
                        formatter: (value, key, item) => {
                            if (value == true) {
                                return "Credit";
                            } else {
                                return "Invoice";
                            }
                        },
                    },
                ],
                item: {},
                items: [],
                selected: []
            }
        };
    },
    computed: {
        readonly() {
            if (this.user.permissions.includes('salesledger.admin')) {
                return false
            }
            return true;
        },
        readonly_age() {
            if (this.user.permissions.includes('salesledger.admin') && this.item.age == 0) {
                return false;
            }
            return true;
        },
    },
    methods: {
        // async loadDDL() {
        //     this.busy = true;

        //     try {
        //         const response = await this.$apollo.query({
        //             query: gql`
        //       query suppliertypes {
        //         suppliertypes {
        //           id
        //           label
        //         }
        //       }
        //     `,
        //         });
        //         this.suppliertype_options = response.data.suppliertypes;
        //     } catch (error) {
        //     }

        //     this.busy = false;
        // },
        async load() {
            await this.lines_load();
        },
        async lines_load(offset, limit, page) {


            if (page) {
                this.lines.page = page
            }

            // if (!this.agent) { return }

            this.lines.busy = true;
            this.lines.items = [];

            let variables = {
                invoiceno: this.selection[0].invoiceno,
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query SLTransactions($invoiceno: String) {
                            SLTransactions(invoiceno: $invoiceno) {
                            invoiceno                          
                            created_at
                            created_by
                            updated_at
                            updated_by
                            remittance {
                               slac
                               to
                               yourref
                               invoiceno
                               date
                               valuecleared
                               itemcleared
                               age
                               linetype
                               items{
                                invoiceno
                                date
                                valuecleared
                                itemcleared
                                age
                                eventcode
                                slac
                                yourref
                                datetravel
                                saletotal
                                outstanding
                                refcredit
                                agent
                                #lines
                               }
                                created_at
                                created_by
                                updated_at
                                updated_by
                            }
                            }
                        }
                    `,
                    variables,
                });


                if (response.data.SLTransactions[0].remittance) {

                    this.item = response.data.SLTransactions[0].remittance
                    this.item.date = this.$moment.unix(this.item.date * 0.001).utc(false).format("YYYY-MM-DD");

                    this.lines.items = this.item.items;

                } else {

                    this.item.invoiceno = "PP<new>"
                    this.item.date = this.$moment().format("YYYY-MM-DD")
                    this.item.slac = this.selection[0].slac
                    this.item.yourref = "BACS " + this.$moment().format("DD.MM.YY")
                    this.lines.items = this.selection

                }

            } catch (error) {
                console.log(error);
            }
            this.lines.busy = false;
        },


        async lines_click(a, ss) {
            console.log("lines_click", a, ss);

            let state = this.lines;

            switch (a) {
                case "selectall":
                    this.lines.selectall = !this.lines.selectall
                    break;
                case "go":
                    this.component = null;
                    await this.lines_load();
                    break;

                case "save":
                    await this.lines_saveit()
                    break;

                case "delete":
                    this.deleteit(ss);
                    break;

            }
        },
        async lines_select(ss, tools) {
            console.log("lines_select", ss);

            let state = this.lines;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "go", "filter", "add", "export"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "notes"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["save", "deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }

            this.credited = 0
            if (state.selected.length > 0) {
                let value = 0
                state.selected.forEach(function (action, index) {
                    value += parseFloat(state.selected[index].saletotal)
                })
                this.credited = value
            } else {
                state.item = {}
            }
        },

        async lines_saveit() {
            this.busy = true;

            let state = this.lines;

            // ONLY SEND WHAT WE ARE ALLOWED TO UPDATE
            let rows = []
            for (var i = 0; i < state.selected.length; ++i) {
                rows.push({
                    // id: state.selected[i].id,
                    // eventcode: state.selected[i].eventcode,
                    // slac: state.selected[i].slac,
                })
            }

            let variables = {
                rows,
            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation saveSLTransactions($rows: [SLTransaction_input]) {
                            saveSLTransactions(rows: $rows) {
                            id
                            }
                        }
                        `,
                    variables,
                });

                await this.lines_load()

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },

        async deleteit(s) {
            console.log("deleteit", s);

            let rows = [];
            s.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
            };

            console.log(variables);
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
            mutation deleteSLTransaction($rows: [SLTransaction_input]) {
              deleteSLTransaction(rows: $rows) {
                id
              }
            }
          `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            await this.sltransactions_load();
        },
    },
};
</script>
  
  
  